/** Pose geométrica para as pontas do alargador na maçaneta ou nos dois apoios da janela. */
export function poseAcessoPorta(progresso: number, alturaEsquadria?: number) {
  const p = Math.max(0, Math.min(1, progresso))
  // Dimensões dos pivôs e ponteiras de AlargadorHolmatro3D, antes da escala 0,72.
  const comprimentoPonta = 0.46
  const alturaPivo = 0.09
  const offsetPonta = 0.045
  const vao = alturaEsquadria == null ? 0.12 - 0.085 * p : alturaEsquadria + 0.06 * p
  const abertura = Math.asin(Math.max(-1, Math.min(1,
      (vao / (2 * 0.72) - alturaPivo) / Math.hypot(comprimentoPonta, offsetPonta),
    ))) - Math.atan2(offsetPonta, comprimentoPonta)
  return {
    anguloMandibula: abertura + 0.28,
    distanciaPonta: 0.06 + comprimentoPonta * Math.cos(abertura) - offsetPonta * Math.sin(abertura),
    vaoPontas: 2 * 0.72 * (alturaPivo + comprimentoPonta * Math.sin(abertura) + offsetPonta * Math.cos(abertura)),
  }
}
